import { MuiPickersUtilsProvider } from "@material-ui/pickers"
import { PersistGate } from "redux-persist/integration/react"
import { Provider } from "react-redux"
import { Router } from "react-router-dom"
import { ThemeProvider } from "@material-ui/core/styles"
import axios from "axios"
import CssBaseline from "@material-ui/core/CssBaseline"
import DateFnsUtils from "@date-io/date-fns" // choose your lib
import get from "lodash/get"
import includes from "lodash/includes"
import React, { Fragment } from "react"
import ReactDOM from "react-dom"
import { ConfirmProvider } from "material-ui-confirm"

import {
  saveCredential,
  clearCrendential,
} from "src/features/Oauth/oauth.ducks"

import { openDialog } from "src/features/Authentication/SessionExpiredDialog.ducks"

import { theme } from "./theme"
import * as serviceWorker from "./serviceWorker"
import App from "./App"
import store, { history, persistor } from "./store"

import "./index.css"

const API_END_POINT = process.env.REACT_APP_API_ENDPOINT
// *********************************
// Add a request interceptor - will move to some file(not here)
// *********************************
axios.interceptors.request.use(
  (config) => {
    const { access_token, refresh_token, ref_code } = store.getState().oauth
    if (access_token) {
      config.headers["Authorization"] = `Bearer ${access_token}`
    }
    if (refresh_token) {
      config.headers["Refresh"] = refresh_token
    }
    if (ref_code) {
      config.headers["Reference"] = ref_code
    }
    // config.headers['Content-Type'] = 'application/json';
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
// *********************************
// Add a response interceptor
// *********************************
axios.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const originalRequest = error.config
    // dispatch show session expired modal.
    const noSessionDialogList = [
      `${API_END_POINT}/profile`,
      `${API_END_POINT}/refresh`,
    ]
    // profile + refresh 403 ไม่ต้องแสดง Popup
    if (
      error.response.status === 403 &&
      !includes(noSessionDialogList, error.config.url)
    ) {
      store.dispatch(openDialog())
    } else if (
      error.response.status === 401 &&
      originalRequest.url === `${API_END_POINT}/refresh`
    ) {
      // COMMENT: Redirect to home due to all token are expired
      store.dispatch(clearCrendential())
      return Promise.reject(error)
    }
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        //- Request New Access-Token from interceptors
        const res = await axios.post(`${API_END_POINT}/refresh`, {})
        if (res.status === 201) {
          const { refresh_token, ref_code } = store.getState().oauth
          const access_token = get(res, "data.token")
          // 1) update token in store
          store.dispatch(saveCredential(access_token, refresh_token, ref_code))
          // 2) Change Authorization header
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${access_token}`
          // 3) return originalRequest object with Axios.
          return axios(originalRequest)
        }
      } catch (error) {
        // return Promise.reject(error);
      }
    }
    return Promise.reject(error)
  }
)

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <ConfirmProvider>
            <Router history={history}>
              <Fragment>
                <CssBaseline />
                <App />
              </Fragment>
            </Router>
          </ConfirmProvider>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
